<template>
  <div class="role_authorization">
    <span>{{ $t('meta_title.role_authorization') }}</span>

    <div class="ibox-content">
      <table v-if="roles !== null" class="table table-striped">
        <thead>
          <tr>
            <th>{{ $t('meta_title.actions') }}</th>

            <th v-for="role in roles">
              {{ $t('role.'+role) }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(authorization,key) in authorizations">
            <td>
              {{ $t('authorization.feature.' + extract_feature(key))
              }} - {{ $t('authorization.action.' + extract_action(key)) }}
            </td>
            <td v-for="role in roles"
                :data-value="authorization[role] !== null ? authorization[role] : 0"
                data-authorization_type="role"
                :data-id="role"
                :data-feature="extract_feature(key)"
                :data-action="extract_action(key)"
                data-url="authorization_add_update"
                @click="changeState($event)">
              <span v-if="authorization[role] && authorization[role] === true">V</span>
              <span v-else>X</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'RoleAuthorization',
    methods: {
      extract_feature(key){
        return key.split('_')[0];
      },
      extract_action(key){
        return key.split('_')[1];
      },
      changeState($event){
        let $elem = $event.currentTarget;

        this.$http.post('authorization', {
          type: $elem.dataset.authorization_type,
          id: $elem.dataset.id,
          action: $elem.dataset.action,
          feature: $elem.dataset.feature,
          value: $elem.dataset.value
        }).then(response => {
          $elem.dataset.value = response.data.authorized == true ? 1 : 0;
          $elem.textContent   = response.data.authorized == true ? 'V' : 'X';
        })
      }
    },
    data() {
      return {
        authorizations: [],
        roles: [],
      }
    },
    created() {
      this.$http.get('role/authorization')
        .then(response => {
          this.roles          = response.data.sub_roles
          this.authorizations = response.data.authorizations
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Role/authorization.vue